export * from './cipafacil.module';
